<template>
  <div id="CreateUpdateVehicle">
    <v-dialog max-width="600" scrollable persistent v-model="vehicleDialog">
      <v-card>
        <v-card-title>{{ vehicle ? 'Update' : 'Create' }} Vehicle</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="py-3">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" class="py-1 mt-5">
                <v-text-field :rules="[rules.vehicleNumberRequired]" dense label="Vehicle Number*"
                              outlined ref="platNo" v-model="vehicleData.platNo"></v-text-field>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-text-field :rules="[rules.nameRequired]" dense label="Vehicle Name*"
                              outlined ref="name" v-model="vehicleData.name"></v-text-field>
              </v-col>
              <v-col class="title black--text py-1" cols="12">Important Dates</v-col>
              <v-col cols="6" class="py-1">
                <v-menu :close-on-content-click="false"  :nudge-right="40" min-width="290px" offset-y
                        transition="scale-transition" v-model="pucEndDateMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="PUC End Date" dense outlined prepend-inner-icon="mdi-calendar" readonly
                                  v-bind="attrs" v-model="pucExpiryDateFormat" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker @input="pucEndDateMenu = false" v-model="vehicleData.pucExpiryDate"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-1">
                <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                        transition="scale-transition" v-model="insuranceDateMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="Insurance Date" dense outlined prepend-inner-icon="mdi-calendar" readonly
                                  v-bind="attrs" v-model="insuranceDateFormat" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker @input="insuranceDateMenu = false" v-model="vehicleData.insuranceDate"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-1">
                <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                        transition="scale-transition" v-model="fitnessCertificateMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="Fitness Certificate" dense outlined prepend-inner-icon="mdi-calendar" readonly
                                  v-bind="attrs" v-model="fitnessCertificateFormat" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker @input="fitnessCertificateMenu = false"
                                 v-model="vehicleData.fitnessCertificate"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-1">
                <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                        transition="scale-transition" v-model="oilChangeOnMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="Oil Change On" dense outlined prepend-inner-icon="mdi-calendar" readonly
                                  v-bind="attrs" v-model="oilChangeOnFormat" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker @input="oilChangeOnMenu = false" v-model="vehicleData.oilChangeOn"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-1">
                <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                        transition="scale-transition" v-model="installmentEmiOnMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="Installment/EMI On" dense outlined prepend-inner-icon="mdi-calendar" readonly
                                  v-bind="attrs" v-model="installmentEmiOnFormat" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker @input="installmentEmiOnMenu = false"
                                 v-model="vehicleData.installmentEmiOn"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-1">
                <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                        transition="scale-transition" v-model="lastServiceMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="Last Service On" dense outlined prepend-inner-icon="mdi-calendar" readonly
                                  v-bind="attrs" v-model="lastServiceFormat" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker @input="lastServiceMenu = false"
                                 v-model="vehicleData.lastServiceOn"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn @click="cancel" class="mr-2 white elevation-0">CANCEL</v-btn>
          <v-btn @click="validate" class="mr-2 primary elevation-0">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { CREATE_UPDATE_VEHICLE } from '../../graphql/mutations/Vehicles'
import moment from 'moment'

export default {
  name: 'CreateUpdateVehicle',
  props: {
    vehicle: { type: [Object], default: null },
    vehicleDialog: { type: [Boolean], default: false },
  },
  data () {
    return {
      vehicleData: {
        platNo: '', name: '',
        pucExpiryDate: null, insuranceDate: null, fitnessCertificate: null,
        oilChangeOn: null, installmentEmiOn: null,lastServiceOn:null
      },
      pucEndDateMenu: false,
      insuranceDateMenu: false,
      fitnessCertificateMenu: false,
      oilChangeOnMenu: false,
      installmentEmiOnMenu: false,
      lastServiceMenu: false,
      rules: {
        vehicleNumberRequired: value => !!value || 'Vehicle Number Required.',
        nameRequired: value => !!value || 'Vehicle Name Required.',
      },
      loggedInUser: JSON.parse(localStorage.user),
    }
  },
  mounted () {
    if (this.vehicle) {
      this.vehicleData = JSON.parse(JSON.stringify(this.vehicle))
      this.vehicleData.pucExpiryDate = this.vehicleData.pucExpiryDate ? moment(this.vehicleData.pucExpiryDate).
          format('YYYY-MM-DD') : null
      this.vehicleData.insuranceDate = this.vehicleData.insuranceDate ? moment(this.vehicleData.insuranceDate).
          format('YYYY-MM-DD') : null
      this.vehicleData.fitnessCertificate = this.vehicleData.fitnessCertificate ? moment(
          this.vehicleData.fitnessCertificate).format('YYYY-MM-DD') : null
      this.vehicleData.oilChangeOn = this.vehicleData.oilChangeOn ? moment(this.vehicleData.oilChangeOn).
          format('YYYY-MM-DD') : null
      this.vehicleData.installmentEmiOn = this.vehicleData.installmentEmiOn ? moment(this.vehicleData.installmentEmiOn).
          format('YYYY-MM-DD') : null
      this.vehicleData.lastServiceOn = this.vehicleData.lastServiceOn ? moment(this.vehicleData.lastServiceOn).
          format('YYYY-MM-DD') : null
    } else
      this.vehicleData['id'] = this.generateUUID()
  },
  watch: {
    'vehicleData.platNo' (val) {
      this.vehicleData.platNo = val.toString().toUpperCase()
    },
  },
  computed: {
    pucExpiryDateFormat () {
      return this.vehicleData.pucExpiryDate
          ? moment(this.vehicleData.pucExpiryDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
          : null
    }, insuranceDateFormat () {
      return this.vehicleData.insuranceDate
          ? moment(this.vehicleData.insuranceDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
          : null
    }, fitnessCertificateFormat () {
      return this.vehicleData.fitnessCertificate ? moment(this.vehicleData.fitnessCertificate, 'YYYY-MM-DD').
          format('DD-MM-YYYY') : null
    }, oilChangeOnFormat () {
      return this.vehicleData.oilChangeOn
          ? moment(this.vehicleData.oilChangeOn, 'YYYY-MM-DD').format('DD-MM-YYYY')
          : null
    }, installmentEmiOnFormat () {
      return this.vehicleData.installmentEmiOn ? moment(this.vehicleData.installmentEmiOn, 'YYYY-MM-DD').
          format('DD-MM-YYYY') : null
    },lastServiceFormat () {
      return this.vehicleData.lastServiceOn ? moment(this.vehicleData.lastServiceOn, 'YYYY-MM-DD').
          format('DD-MM-YYYY') : null
    },
  },
  methods: {
    validate () {
      if (this.$refs.form.validate())
        this.saveTempo()
    },
    async saveTempo () {
      let vehicleObj = {
        id: this.vehicleData.id,
        name: this.vehicleData.name,
        platNo: this.vehicleData.platNo,
        type: 'TEMPO',
        pucExpiryDate: this.vehicleData.pucExpiryDate,
        insuranceDate: this.vehicleData.insuranceDate,
        fitnessCertificate: this.vehicleData.fitnessCertificate,
        oilChangeOn: this.vehicleData.oilChangeOn,
        installmentEmiOn: this.vehicleData.installmentEmiOn,
        lastServiceOn: this.vehicleData.lastServiceOn,
        organizationId: this.loggedInUser.organizationId,
      }
      let vehicle_on_conflict_rule = {
        constraint: 'Vehicles_pkey',
        update_columns: [
          'name', 'platNo', 'type', 'pucExpiryDate', 'insuranceDate', 'fitnessCertificate', 'oilChangeOn',
          'installmentEmiOn', 'lastServiceOn', 'organizationId'],
      }
      let response = await this.$apollo.mutate({
        mutation: CREATE_UPDATE_VEHICLE,
        variables: { vehicles: vehicleObj, vehicle_on_conflict_rule: vehicle_on_conflict_rule },
      })
      if (response.data)
        this.$emit('saveTempo')
    },
    cancel () {
      this.$emit('cancel')
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
  },
}
</script>

<style scoped>
/deep/ .v-card__text {
  padding: 0 20px 0 !important;
}
</style>
